module.exports = __webpack_public_path__ + "b8b579f12d66c64fe1c0553ec2a579df.svg";